<script setup lang="ts">
  import { IOrder } from '@/interfaces/IOrder';
  import { ITable } from '@/interfaces/ITable';
  import { useRestaurantStore } from '@/stores/restaurant.store';
  import { displayPrice } from '@/utils';
  import { computed } from 'vue';

  const props = defineProps<{
    table: ITable;
    orders: IOrder[];
    selectedOrders: IOrder[];
  }>();

  const restaurantStore = useRestaurantStore();

  const totals = computed(() => {
    return {
      count: props.orders.length,
      total: props.orders.reduce((acc, order) => acc + order.total, 0),
      selectedCount: props.selectedOrders.length,
      selectedTotal: props.selectedOrders.reduce(
        (acc, order) => acc + order.total,
        0
      ),
    };
  });
</script>

<template>
  <div class="table-summary">
    <div v-if="selectedOrders.length" class="summary-row">
      <span class="row-title">Pedidos seleccionados</span>
      <span class="row-separator"></span>
      <span class="count"
        >{{ totals.selectedCount }} de {{ totals.count }}
      </span>
      <span class="row-separator"></span>
      <span class="total"
        >{{ restaurantStore.currency.symbol
        }}{{ displayPrice(totals.selectedTotal) }}</span
      >
    </div>
    <div v-else class="summary-row">
      <span class="row-title">Total mesa</span>
      <span class="row-separator"></span>
      <span class="count">{{ totals.count }} pedidos</span>
      <span class="row-separator"></span>
      <span class="total"
        >{{ restaurantStore.currency.symbol
        }}{{ displayPrice(totals.total) }}</span
      >
    </div>
  </div>
</template>

<style scoped lang="scss">
  .table-summary {
    @apply tw-px-2 tw-py-2;

    .summary-row {
      @apply tw-flex tw-justify-end tw-items-center tw-space-x-2;

      .row-title {
        @apply tw-text-xs tw-font-medium tw-text-gray-500 tw-tracking-wider tw-uppercase;
      }

      .row-separator {
        @apply tw-w-1 tw-h-1 tw-bg-gray-300 tw-rounded-full;
      }

      .count {
        @apply tw-text-base tw-font-medium tw-text-gray-500;
      }

      .total {
        @apply tw-text-base tw-font-medium;
      }
    }
  }
</style>
